import { useEffect, useState, useCallback } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import JlptHome from './pages/JlptHome';
import N5Landing from './pages/jlpt/n5/N5Landing';
import N4Landing from './pages/jlpt/n4/N4Landing';
import N3Landing from './pages/jlpt/n3/N3Landing';
import N2Landing from './pages/jlpt/n2/N2Landing';
import N1Landing from './pages/jlpt/n1/N1Landing';

import AdUnit from './components/ads/AdUnit';
import { initGA, logPageView } from './utils/analytics';

const MOBILE_BREAKPOINT = 768;

// Placeholder for your AdSense config (Ensure you replace these with your actual IDs)
const ADS = {
  client: 'ca-pub-2811591266080010',
  mobileTopSlot: '2331374547'
};

export default function App() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen(prev => !prev);
  }, []);

  useEffect(() => {
    initGA();
    logPageView(window.location.pathname);

    const handleResize = () => {
      const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(newIsMobile);

      if (!newIsMobile) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      setIsSidebarOpen(true);
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const effectiveSidebarOpen = isSidebarOpen;

  const currentYear = new Date().getFullYear();

  const mainContentStyle = {
    marginLeft: isMobile ? 0 : 220,
    padding: '1rem',
    width: '100%',
    boxSizing: 'border-box',
    minHeight: '100vh',
    transition: 'margin-left 0.3s ease',
    flexGrow: 1,
    paddingBottom: isMobile ? '65px' : '1rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  // Updated style for the footer to allow flexible internal layout (Flex/Grid)
  const footerStyle = {
    marginTop: 'auto',
    padding: '2rem 1rem 1rem', // Added top padding for separation
    borderTop: '1px solid #eee',
    width: '100%',
    boxSizing: 'border-box',

    // New Flex Layout for future multi-column/section support
    display: 'flex',
    flexDirection: 'column', // Stack sections vertically on small screen
    alignItems: 'center', // Center content horizontally
    gap: '1.5rem', // Space between sections
  };

  // Style for the copyright/contact area
  const infoStyle = {
    textAlign: 'center',
    fontSize: '0.85rem',
    color: '#666',
  };

  return (
    <Router>
      <div style={{ display: 'flex', position: 'relative' }}>

        <Sidebar
          isMobile={isMobile}
          isOpen={effectiveSidebarOpen}
          toggleSidebar={toggleSidebar}
        />

        {/* Mobile Hamburger Button */}
        {isMobile && !isSidebarOpen && (
          <button
            onClick={toggleSidebar}
            style={{
              position: 'fixed',
              top: '10px',
              left: '10px',
              zIndex: 1000,
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              padding: '0.5rem 0.75rem',
              fontSize: '1.5rem',
              cursor: 'pointer',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            }}
            aria-label="Open navigation menu"
          >
            ☰
          </button>
        )}

        {/* Main Content Wrapper */}
        <div style={mainContentStyle}>

          <div style={{ paddingTop: isMobile ? '40px' : '0', flexGrow: 1 }}>

            {/* MOBILE TOP NON-FIXED BANNER AD */}
            {isMobile && (
              <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                <AdUnit
                  client={ADS.client}
                  slot={ADS.mobileTopSlot}
                  format="auto"
                  fullWidth={true}
                  style={{ display: 'inline-block', minHeight: '50px', width: '100%' }}
                />
              </div>
            )}

            <Switch>
              {/* NEW: Use the N5Landing component here */}
              
              <Route path="/old_questions/n1">
                <N1Landing/>
              </Route>
              <Route path="/old_questions/n2">
                <N2Landing />
              </Route>
              <Route path="/old_questions/n3">
                <N3Landing />
              </Route>
              <Route path="/old_questions/n4">
                <N4Landing />
              </Route>
              <Route path="/old_questions/n5">
                <N5Landing />
              </Route>
              {/* <Route path="/old_questions/n5"><JlptHome defaultLevel="n5" /></Route> */}
              <Route exact path="/">
                <JlptHome defaultLevel="/#/" />
              </Route>
            </Switch>
          </div>

          {/* ---------------------------------------------------
            FOOTER - STRUCTURED FOR FUTURE MENU AND SOCIAL MEDIA
            --------------------------------------------------- */}
          <footer style={footerStyle}>

            {/* Future: Menu Links Section (Hidden/Empty for now) */}
            <div id="footer-menu-links">
              {/* When ready, add: <ul><li><Link to="/about">About</Link></li>...</ul> */}
            </div>

            {/* Future: Social Media Section (Hidden/Empty for now) */}
            <div id="footer-social-media">
              {/* When ready, add: <a href="#"><i class="fa fa-facebook"></i></a> etc. */}
            </div>

            {/* Copyright and Contact Information (Current content) */}
            <div style={infoStyle}>
              <p>
                &copy; {currentYear} OMGJLPT. All rights reserved.
              </p>
              <p style={{ marginTop: '5px' }}>
                Contact: <a href="mailto:omgjlpt2026@gmail.com" style={{ color: '#1976d2', textDecoration: 'none' }}>omgjlpt2026@gmail.com</a>
              </p>
            </div>

          </footer>
        </div>

        {/* Overlay for Mobile Sidebar */}
        {isMobile && isSidebarOpen && (
          <div
            onClick={toggleSidebar}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.4)',
              zIndex: 998,
            }}
          />
        )}
      </div>
    </Router>
  );
}